/**
 * Internal dependencies
 */

import createConfig from 'lib/create-config';

import { CUSTOMER_SITE_PROXY_URL, OAUTH2_SERVER_URL, CLIENT_URL } from './hosts';

const configApi = createConfig({
    customerSiteProxy: CUSTOMER_SITE_PROXY_URL,
    oauth2ServerUrl:   OAUTH2_SERVER_URL,
    clientUrl:         CLIENT_URL,
});

export default configApi;